import type { JwtPayload } from "./types";

/**
 * Decodes a JWT without verifying signature.
 * Client-safe: does not pull in jsonwebtoken or crypto polyfills (buffer, stream, etc.).
 * Uses standard browser APIs (atob, TextDecoder).
 */
export const decodeJwt = (token: string): JwtPayload | null => {
  try {
    if (!token) return null;

    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const base64Url = parts[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    const pad = base64.length % 4;
    if (pad) {
      if (pad === 1) return null; // Longitud inválida
      base64 += "=".repeat(4 - pad);
    }

    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const jsonPayload = new TextDecoder().decode(bytes);

    return JSON.parse(jsonPayload);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    // Fail silently: callers handle null
    return null;
  }
};
